import { render } from "./TakeLoanCustomerView.vue?vue&type=template&id=80e55aea&scoped=true"
import script from "./TakeLoanCustomerView.vue?vue&type=script&lang=js"
export * from "./TakeLoanCustomerView.vue?vue&type=script&lang=js"

import "./TakeLoanCustomerView.vue?vue&type=style&index=0&id=80e55aea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e55aea"]])

export default __exports__